import HideBranchJourney from './HideBranchJourney';

export default HideBranchJourney;
